<template>
    <app-wrapper>
        <app-header :loan="loan" medium-max-width="max-w-1000">
            <template #top>
                <div class="w-full flex items-center">
                    <div class="flex-auto">
                        Welcome back!
                        <h2 class="mb-0 mt-2 md:mt-4 md:text-4xl">Ready for a new loan?</h2>
                    </div>
                    <div class="flex-initial">
                        <i class="fa fa-hand-wave text-warning text-5xl"/>
                    </div>
                </div>
            </template>
        </app-header>
        <app-body medium-max-width="max-w-1000">
            <template #text>
                <div class="mb-4">
                    <p class="text-gray-600 mb-1">Previous Loan Amount</p>
                    <p class="font-medium text-gray-900 text-lg">{{ loan.amount | money(0) }}</p>
                </div>

                <ReApplyButton
                    :loan="loan"
                    button-text="Apply for a New Loan"
                    :redirect-after-success="true"
                />
            </template>

        </app-body>
    </app-wrapper>
</template>

<script>
import ReApplyButton from '../../../components/ReApplyButton.vue';

export default {
    mixins: [require('../../../mixins/InteractsWithGtag').default],

    components: {
        ReApplyButton
    },

    props: ['loan'],

    data() {
        return {
            gTagPageName: 'introxl-reapply',
        }
    },

    created() {
        this.gTagEvent('introxl-reapply', {
            event_category: 'onboarding',
            event_label: 'introxl-reapply',
        });
    },
}
</script>